import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Drawer,
  Grid,
  IconButton,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import config from '../../../Config/config.json'
import dayjs from "dayjs";
import {
  callAPI,
  clearRequest,
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  Method,
  TransactionPages
} from "../../../commonFunctions/CommonFunctions";
import WSButton from "../../../Components/Button/WSButton";
import WSDateField from "../../../Components/DateField/WSDateField";
import {
  HeaderList,
  IHeaderListActions
} from "../../../Components/Header/HeaderList";

import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSTimePicker from "../../../Components/WSTimePicker/WSTimePicker";
import OrderSummary from "./OrderSummary";
import { ProductListUI } from "./ProductListUI";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import ConfirmDialog from "../Compo/ConfirmationModal";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { Add, Close, Remove } from "@mui/icons-material";
import { CompanyData } from "../OrdersListUI";

interface ProductProp {
  productId: string;
  productName: string;
  imageUrl: string;
  types: {
    productType: string;
    services: {
      serviceId: string;
      serviceName: string;
      shortName: string;
      isWeightBased: boolean;
      weightPrice: number;
      price: number;
    }[];
  }[];
}

type MappedProduct = {
  productId: string;
  productName: string;
  imageUrl: string;
  price: number;
};

export interface PrintData  {
  orderNumber: string;
  customerName: string;
  orderItems: {
    productId: string;
    productName: string;
    serviceName: string;
    quantity: number;
    itemTag: string;
  }[];
  // franchise?: {
  //   name: string;
  //   owner: string;
  //   contactNumber: string;
  //   addressLine1: string;
  //   addressLine2: string;
  //   city: string;
  //   state: string;
  //   pincode: string;
  // };
};

interface CustomerType {
  customerId: string;
  fullName: string;
  phoneNumber: string;
  address: string;
  email?: string;
}

const customOrder = [
  "Laundry By Weight",
  "Shirt",
  "T-shirt",
  "Top",
  "Dothi"
];

const generateEmailFromName = (
  name: string,
  phone: string,
  customers: any[]
) => {
  const formattedName = name.replace(/\s+/g, "").toLowerCase(); // remove spaces, make lowercase
  const existing = customers.find(
    (cust) => cust.fullName.toLowerCase() === name.toLowerCase()
  );

  if (existing) {
    // if same name exists, add last 3 digits of phone
    const lastThreeDigits = phone.slice(-3);
    return `${formattedName}${lastThreeDigits}@gmail.com`;
  } else {
    // if unique name, just use name
    return `${formattedName}@gmail.com`;
  }
};

export const WalkInOrder: React.FC = () => {
  const [company, setCompany] = useState<CompanyData | null>(null);
  
    const franchiseId = getLocalValue(LoacalVariables.FranchiseId);
  
    useEffect(() => {
      const fetchCompany = async () => {
        const response = await callAPI(
          "franchises",
          Method.GET,
          null,
          franchiseId
        );
        console.log("response franchise", response);
        setCompany(response.data);
      };
  
      fetchCompany();
    }, []);

  const { control, register, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      customerName: "",
      phoneNumber: "",
      deliveryAddress: "",
      deliveryDate: "",
      deliveryTime: "",
      isHomeDelivery: true,
      franchiseId: franchiseId,
      status: "New",
      searchQuery: ""
    }
  });
  const { edit, add } = getPermissions(
    TransactionPages.PaymentList,
    IRoleMain.Transactions
  );
  const navigate = useNavigate();
  const params = useParams();
  const id = params?.id;
  const { showMessage } = useSnackbar();

  const [loading, setLoading] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [productQuantities, setProductQuantities] = useState<
    Record<string, number>
  >({}); // for product in laundry by weight;
  const [mappedProducts, setMappedProducts] = useState<MappedProduct[]>([]);
  const [products, setProducts] = useState<any[]>([]);
  const [addonServices, setAddonServices] = useState<any[]>([]);

  const [selectedProduct, setSelectedProduct] = useState<ProductProp | null>(
    null
  );
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [selectedServices, setSelectedServices] = useState<any[]>([]);

  const [orderItems, setOrderItems] = useState<any>([]);
  const [orderId, setOrderId] = useState<string>();
  const [printData, setPrintData] = useState<any>(null);
  const [openPrintModal, setOpenPrintModal] = useState(false);

  //this state data is for order table;
  const [productDetails, setProductDetails] = useState({
    quantity: 1,
    services: [],
    addOns: []
  });
  const [totalAmount, setTotalAmount] = useState(0);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const [selectedAddons, setSelectedAddons] = useState<any>([]);

  const [quantity, setQuantity] = useState(1);

  //custmer;
  const [weight, setWeight] = useState(1);
  const [customers, setCustomers] = useState<CustomerType[]>([]);
  const [isNewCustomer, setIsNewCustomer] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | null>(
    null
  );

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await callAPI("customers", Method.GET);
        
        if (response.success) {
          setCustomers(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch customers", error);
      }
    };

    fetchCustomers();
  }, []);

  useEffect(() => {
    if (selectedProduct?.types?.length === 1) {
      // Auto-select the only available type
      setSelectedType(selectedProduct.types[0].productType);
    }
  }, [selectedProduct]);

  //for fill customer data with phoneNumber;
  const phoneNumber = watch("phoneNumber");

  useEffect(() => {
    if (phoneNumber && phoneNumber.length >= 10) {
      const existingCustomer = customers.find(
        (cust) => cust.phoneNumber === phoneNumber
      );

      if (existingCustomer) {
        setValue("customerName", existingCustomer.fullName);
        setValue("deliveryAddress", existingCustomer.address);
        setIsNewCustomer(false);
        setSelectedCustomerId(existingCustomer.customerId);
      } else {
        setValue("customerName", "");
        setValue("deliveryAddress", "");
        setIsNewCustomer(true);
        setSelectedCustomerId(null);
      }
    }
  }, [phoneNumber, customers, setValue]);

  const handleWeightChange = (value: number) => {
    setWeight(value < 1 ? 1 : value);
  };

  const handleServiceClick = async (service: any) => {
    const isWeightBased = service.isWeightBased;
    

    if (isWeightBased) {
      try {
        const response: any = await callAPI(
          `Mapping/products-by-service/${service.serviceId}`,
          Method.GET
        );

        

        // Step 1: Flatten all product data
        const allProducts: MappedProduct[] = response
          .flatMap((service: any) => service.productTypes)
          .flatMap((type: any) => type.products)
          .filter(Boolean); // remove nulls/undefined

        // Step 2: Remove duplicates based on productId
        const uniqueProducts = Array.from(
          new Map(
            allProducts.map((product) => [product.productId, product])
          ).values()
        );

        

        setMappedProducts(uniqueProducts);
      } catch (err) {
        console.error("Error fetching weight-based products", err);
        showMessage("Error fetching weight-based products", "error");
      }
    }

    // Service select/deselect logic
    setSelectedServices((prev: any) => {
      const updatedServices = prev.some(
        (s: any) => s.serviceId === service.serviceId
      )
        ? prev.filter((s: any) => s.serviceId !== service.serviceId)
        : [...prev, service];

      setProductDetails((prevDetails) => ({
        ...prevDetails,
        services: updatedServices
      }));
      return updatedServices;
    });
  };

  const handleProductQuantityChange = (productId: string, newQty: number) => {
    if (newQty < 0) return; // Prevent 0 or negative
    setProductQuantities((prev) => ({
      ...prev,
      [productId]: newQty
    }));
  };

  const handleAddonClick = (addon: any) => {
    setSelectedAddons((prev: any) => {
      const updatedAddons = prev.some((a: any) => a.addOnId === addon.addOnId)
        ? prev.filter((a: any) => a.addOnId !== addon.addOnId)
        : [...prev, addon];

      setProductDetails((prevDetails) => ({
        ...prevDetails,
        addOns: updatedAddons // Ensure correct addon selection
      }));

      return updatedAddons;
    });
  };

  const handleQuantityChange = (newQuantity: number) => {
    setQuantity(newQuantity);
    setProductDetails((prevDetails) => ({
      ...prevDetails,
      quantity: newQuantity
    }));
  };
  const getProductsWithServices = async () => {
    try {
      const response: any = await callAPI(
        "Mapping/products-grouped-by-type",
        Method.GET,
        null,
        null
      );

      if (response) {
        const reorderedProducts = [
          ...customOrder.flatMap(name =>
            response.filter((p:any) => p.productName === name)
          ),
          ...response.filter((p:any)=> !customOrder.includes(p.productName))
        ];

        setProducts(reorderedProducts);
      }
    } catch (e) {
      console.error("Error fetching products", e);
    } finally {
      setLoading(false);
    }
  };

  const getAddonServices = async () => {
    try {
      const response: any = await callAPI(
        "service-addons",
        Method.GET,
        null,
        null
      );

      if (response) {
        setAddonServices(response.data);
      }
    } catch (e) {
      console.error("Error fetching addon services", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function getOrderById(id: any) {
      try {
        const response: any = await callAPI("orders", Method.GET, null, id);
        

        if (response && response?.data) {
          setValue("customerName", response.data.customerName);
          setValue("phoneNumber", response.data.phoneNumber);
          setValue("deliveryAddress", response.data.deliveryAddress);

          // Convert deliveryDate to MM/DD/YYYY format;
          const formattedDate = dayjs(response.data.deliveryDate).format(
            "MM/DD/YYYY"
          );
          setValue("deliveryDate", formattedDate);

          setValue("deliveryTime", response.data.deliveryTime);
          setValue("franchiseId", response.data.franchiseId);
          // setValue("taxAmount", response.data.taxAmount);
          setTotalAmount(response.data.totalAmount);

          // Populate order items
          if (
            response.data.orderItems &&
            Array.isArray(response.data.orderItems)
          ) {
            const mappedItems = response.data.orderItems.map((item: any) => ({
              serviceId: item.serviceId,
              productId: item.productId,
              price: item.price,
              quantity: item.quantity,
              weight: item.weight,
              productName: item.productName,
              productType: item.productType,
              serviceName: item.serviceName,
              itemTag: item.itemTag,
              serviceAddOns: item.serviceAddOns
            }));

            setOrderItems(mappedItems);
          }
        }
      } catch (error) {
        console.error("Failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }

    if (id) {
      getOrderById(id);
    }
  }, [id, setValue]);

  useEffect(() => {
    const fetchOrderById = async () => {
      try {
        const response: any = await callAPI(
          "orders",
          Method.GET,
          null,
          orderId
        );

        if (response && response?.data) {
          const order = response.data;

          // Transform data to match `PrintData` format
          const formattedData: PrintData = {
            orderNumber: order.orderNumber,
            customerName: order.customerName,
            orderItems: order.orderItems.map((item: any) => ({
              productId: item.productId,
              productName: item.productName,
              serviceName: item.serviceName,
              quantity: item.quantity,
              itemTag: item.itemTag
            }))
          };

          setPrintData(formattedData);
          setOpenPrintModal(true);
        }
      } catch (error) {
        console.error("Failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    if (orderId) fetchOrderById();
  }, [orderId]);

  useEffect(() => {
    getProductsWithServices();
    getAddonServices();
  }, []);

  const openDrawer = (product: ProductProp) => {
    setSelectedProduct(product);
    setSelectedType(null); // Reset selected type when opening drawer
    setSelectedServices([]);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedProduct(null);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  // Save product for order
  const handleSaveProduct = () => {
    if (!selectedType) {
      showMessage("No product type selected", "error");
      return;
    }

    if (selectedServices.length === 0 && productDetails.addOns.length === 0) {
      showMessage("No services chosen", "error");
      return;
    }
    

    const isWeightBased = selectedServices.some((s) => s.isWeightBased);

    type OrderItem = {
      serviceId: string;
      productId: string;
      productType: string;
      quantity: number;
      weight?:number;
      price: number;
      isWeightBased: boolean;
      totalWeight?: number;
      itemTag: string;
      serviceName: string;
      productName: string;
      serviceAddOns: any[];
    };

    let newOrderItems: OrderItem[] = [];
    

    if (isWeightBased) {
      // Filter out products with 0 or undefined quantity
      const validProducts = mappedProducts.filter(
        (product) => productQuantities[product.productId] > 0
      );

      

      validProducts.forEach((product) => {
        selectedServices.forEach((service) => {
          newOrderItems.push({
            serviceId: service.serviceId,
            productId: product.productId,
            productType: selectedType,
            quantity: productQuantities[product.productId],
            weight:weight,
            price: service.price,
            isWeightBased: true,
            totalWeight: weight,
            itemTag: `${Math.floor(100 + Math.random() * 900)}.${Math.floor(
              100 + Math.random() * 900
            )}`,
            serviceName: service.serviceName,
            productName: product.productName,
            serviceAddOns: productDetails.addOns
          });
        });
      });
    } else {
      // Use selectedProduct for non-weight-based services
      if (!selectedProduct) {
        showMessage("No product selected", "error");
        return;
      }

      newOrderItems = selectedServices.map(
        (service): OrderItem => ({
          serviceId: service.serviceId,
          productId: selectedProduct.productId,
          productType: selectedType,
          quantity: productDetails.quantity,
          price: service.price,
          isWeightBased: false,
          itemTag: `${Math.floor(100 + Math.random() * 900)}.${Math.floor(
            100 + Math.random() * 900
          )}`,
          serviceName: service.serviceName,
          productName: selectedProduct.productName,
          serviceAddOns: productDetails.addOns
        })
      );
    }

    
    setOrderItems((prevItems: OrderItem[]) => [...prevItems, ...newOrderItems]);

    setQuantity(1);
    setProductDetails({ quantity: 1, services: [], addOns: [] });
    closeDrawer();
  };

  // Delete product-service from order list
  const handleDelete = (productId: string) => {
    setOrderItems((prevItems: any) =>
      prevItems.filter((item: any) => !(item.productId === productId))
    );
  };

  //submit data to server;
  const handleOrder = async (data: any) => {
    
    if (orderItems.length === 0) {
      showMessage("No products added to the order", "error");
      return;
    }
    try {
      let customerId = selectedCustomerId;

      // 🛑 If it's a new customer, create customer first
      if (isNewCustomer) {
        const email = generateEmailFromName(
          data.customerName,
          data.phoneNumber,
          customers
        );
        

        const newCustomerData = {
          fullName: data.customerName,
          phoneNumber: data.phoneNumber,
          address: data.deliveryAddress,
          email: email,
          password: "123"
        };

        const newRequest = clearRequest(newCustomerData);
        

        const newCustomerResponse = await callAPI(
          "customers/register",
          Method.POST,
          newRequest
        );

        

        if (newCustomerResponse?.success) {
          customerId = newCustomerResponse.data.customerId;
        } else {
          showMessage(
            newCustomerResponse.message || "Failed to create customer",
            "error"
          );
          return;
        }
      }

      let request = {
        franchiseId: franchiseId,
        customerId: customerId,
        customerName: data.customerName,
        phoneNumber: data.phoneNumber,
        deliveryAddress: data.deliveryAddress,
        deliveryDate: dayjs(data.deliverDate).format("YYYY-MM-DDTHH:mm:ss.SSS"),
        deliveryTime: data.deliveryTime,
        isHomeDelivery: data.isHomeDelivery || true,
        orderItems: orderItems,
        totalAmount: totalAmount,
        finalAmount: totalAmount,
        totalItemCount: orderItems.length,
        orderStatus: data.status || "New",
        orderDate: new Date().toISOString()
      };

      
      const newRequest = clearRequest(request);

      const endpoint = id ? `orders/${id}` : "orders";

      const method = id ? Method.PUT : Method.POST;

      const response: any = await callAPI(endpoint, method, newRequest);

      if (response) {
        showMessage(response?.message, "success");
        if (!id) {
          setOrderId(response.data);
        } else {
          response.success === true && navigate("/home");
        }
      }
    } catch (e: any) {
      console.error("error is", e);
      showMessage(e.error);
    }
  };

  const handleCancelClick = () => {
    navigate("/home");
  };

  const handlePrint = () => {
    
    if (!printData || !printData.orderItems) return;

    const expandedItems = printData.orderItems.flatMap((item: any) =>
      Array.from({ length: item.quantity }, () => item)
    );

    // Open a single print window
    const printWindow = window.open("", "_blank", "width=800,height=400");
    if (printWindow) {
      const applyMargin = franchiseId === "f98f89ab-c91e-4558-be99-6698fa93b738";
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Tags</title>
            <style>
              body { 
                font-family: Arial, sans-serif; 
                padding: 0; 
                margin: 0; 
              }
      
              .tag-container { 
          text-align: center; 
          width: 170px;
          height: 200px;
          display: flex;
          flex-direction: column;
          justify-content: ${applyMargin ? "flex-start" : "center"};
          align-items: ${applyMargin ? "flex-start" : "center"};
          line-height: 1.5;
          ${applyMargin ? "margin-right: 14px; padding-top: 10px;" : ""}
        }
      
              .tag-title {
                font-size: 14px;
                font-weight: bold;
                margin: 0;
                padding: 0;
              }
      
              p {
                font-size: 14px;
                margin: 2px 0;
              }
      
              @media print {
                body {
                  display: block;
                }
              }
            </style>
          </head>
          <body>
      `);

      expandedItems.forEach((item: any, index: number) => {
        printWindow.document.write(`
            <div class="tag-container">
                <p class="tag-title">3 Fold ${company?.city}</p>
                <p>${printData.customerName}</p>
                <p>${new Date().toLocaleDateString()}</p>
                <span style="font-size:15px; font-weight: bold;">#${
                  printData.orderNumber
                }</span>
                <p style="margin-top:4px; margin-bottom:3px">${
                  item.serviceName
                }</p>
                <p>${item.productName}</p>
                <p>T ${expandedItems.length}</p>
            </div>
            ${
              index !== expandedItems.length - 1
                ? '<div style="page-break-after: always;"></div>'
                : ""
            }
        `);
      });

      // Close the HTML and trigger print
      printWindow.document.write(`</body></html>`);
      printWindow.document.close();
      printWindow.print();
    }
    setOpenPrintModal(false);
    navigate("/home");
  };

  // Remove duplicate products based on `productId`;
  const uniqueProducts = [
    ...new Map(products.map((product) => [product.productId, product])).values()
  ];

  //Apply search filter;
  const filteredProducts = uniqueProducts.filter((product) =>
    product.productName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const actions: IHeaderListActions[] = [
    {
      type: "icon",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "error",
      icon: <WSIcons.CancelIcon />
    },
    {
      type: "icon",
      text: "Save",
      size: "small",
      buttonType: "submit",
      variant: "outlined",
      color: "success",
      icon: <WSIcons.SaveIcon />
    }
  ];

  return (
    <>
      {add && (
        <form onSubmit={handleSubmit(handleOrder)}>
          <HeaderList
            title={id ? "Update Walk In Order" : "Create Walk In Order"}
            type="card"
            actions={actions}
          />
          <Grid container spacing={2} marginTop={0}>
            {/* Left Side - Customer Details */}
            <Grid item xs={12} sm={8} sx={{ mt: 0 }}>
              <Card sx={{ borderRadius: "10px", padding: 3, mt: 0 }}>
                <CardContent>
                  <Typography variant="body1" mb={2}>
                    Customer Details
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <WSTextField
                        label={"Phone Number"}
                        id="phoneNumber"
                        name="phoneNumber"
                        rules={{ required: "Phone Number is required" }}
                        control={control}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <WSTextField
                        label={"Customer Name"}
                        id="customerName"
                        name="customerName"
                        rules={{ required: "Customer Name is required" }}
                        control={control}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <WSDateField
                        label={"Delivery Date"}
                        id="deliveryDate"
                        name="deliveryDate"
                        rules={{ required: "Delivery Date is required" }}
                        control={control}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <WSTimePicker
                        label={"Delivery Time"}
                        id="deliveryTime"
                        name="deliveryTime"
                        rules={{ required: "Delivery Time is required" }}
                        control={control}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <WSTextField
                        label={"Delivery Address"}
                        id="deliveryAddress"
                        name="deliveryAddress"
                        rules={{ required: "Delivery Address is required" }}
                        control={control}
                      />
                    </Grid>
                  </Grid>

                  {/* Order Summary */}
                  <Box mt={3}>
                    <OrderSummary
                      orders={orderItems}
                      handleDelete={handleDelete}
                      setTotalAmount={setTotalAmount}
                      loading={id ? loading : false}
                      weight={
                        selectedServices.some((s) => s.isWeightBased)
                          ? weight
                          : 0
                      }
                    />
                  </Box>
                </CardContent>
              </Card>
                       
            </Grid>

            {/* Right Side */}

            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  borderRadius: "10px",
                  padding: 3,
                  height: "40rem",
                  mt: 0
                }}
              >
                <Typography variant="body1">Select Products</Typography>
                <CardContent>
                  <Divider sx={{ marginY: 2 }} />

                  {/* Search Input Field */}
                  <WSTextField
                    id="search"
                    label="Search Product"
                    variant="outlined"
                    size="small"
                    defaultValue={searchQuery}
                    {...register("searchQuery", { onChange: handleSearch })}
                    sx={{ marginBottom: 4 }}
                    control={control}
                    name="searchQuery"
                  />

                  {/* Scrollable Product List */}
                  <ProductListUI
                    filteredProducts={filteredProducts}
                    orderItems={orderItems}
                    loading={loading}
                    openDrawer={openDrawer}
                  />

                  {/* Drawer UI */}
                  {/* <DrawerUI
                  closeDrawer={closeDrawer}
                  control={control}
                  handleSaveProduct={handleSaveProduct}
                  handleServiceChange={handleServiceChange}
                  isDrawerOpen={isDrawerOpen}
                  selectedProduct={selectedProduct}
                  setProductDetails={setProductDetails}
                  orderItems={orderItems}
                  
                /> */}

                  <Drawer
                    anchor="right"
                    open={isDrawerOpen}
                    onClose={closeDrawer}
                  >
                    <Box sx={{ width: 400, p: 3 }}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography variant="h6" fontWeight="bold">
                          {selectedProduct?.productName}
                        </Typography>
                        <IconButton onClick={closeDrawer}>
                          <Close />
                        </IconButton>
                      </Box>

                      <Divider sx={{ my: 2 }} />

                      {/* Type Selection */}
                      <Typography variant="subtitle1" fontWeight="bold">
                        {`Select ${selectedProduct?.productName} Type`}
                      </Typography>

                      <ToggleButtonGroup
                        value={selectedType}
                        exclusive
                        onChange={(_, newType) => setSelectedType(newType)}
                        sx={{
                          my: 1,
                          display: "grid",
                          gridTemplateColumns: "repeat(3, 1fr)",
                          gap: 1
                        }}
                      >
                        {selectedProduct?.types.map((type) => (
                          <ToggleButton
                            key={type.productType}
                            value={type.productType}
                            sx={{
                              textAlign: "center",
                              justifyContent: "center"
                            }}
                          >
                            {type.productType}
                          </ToggleButton>
                        ))}
                      </ToggleButtonGroup>

                      {/* Services Based on Selected Type */}
                      {selectedType ? (
                        <>
                          <Typography variant="subtitle1" fontWeight="bold">
                            Select one or more services *
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 1,
                              my: 1
                            }}
                          >
                            {selectedProduct?.types
                              .find((t) => t.productType === selectedType)
                              ?.services.map((service) => (
                                <Button
                                key={service.serviceId}
                                variant={
                                  selectedServices.some((s) => s.serviceId === service.serviceId)
                                    ? "contained"
                                    : "outlined"
                                }
                                disabled={
                                  selectedServices.length > 0 &&
                                  selectedServices[0].isWeightBased &&
                                  selectedServices[0].serviceId !== service.serviceId
                                }
                                onClick={() => handleServiceClick(service)}
                              >
                                {service.serviceName} [ ₹ {service.price} ]
                              </Button>
                              
                              ))}
                          </Box>
                        </>
                      ) : (
                        <>
                          <Typography variant="subtitle1" fontWeight="bold">
                            Select one or more services *
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 1,
                              my: 1
                            }}
                          >
                            {selectedProduct?.types

                              .find(
                                (t) =>
                                  t.productType ===
                                  selectedProduct?.types[0].productType
                              )
                              ?.services.map((service) => (
                                <Button
                                  key={service.serviceId}
                                  variant={
                                    selectedServices.some(
                                      (s) => s.serviceId === service.serviceId
                                    )
                                      ? "contained"
                                      : "outlined"
                                  }
                                  onClick={() => handleServiceClick(service)}
                                >
                                  {service.serviceName} [ ₹ {service.price} ]
                                </Button>
                              ))}
                          </Box>
                        </>
                      )}

                      {/* add on services */}
                      <Typography variant="subtitle1" fontWeight="bold">
                        Add On Services
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          flexWrap: "wrap",
                          my: 1
                        }}
                      >
                        {addonServices.map((addOn) => (
                          <Button
                            key={addOn.addOnId}
                            variant={
                              selectedAddons.some(
                                (s: any) => s.addOnName === addOn.addOnName
                              )
                                ? "contained"
                                : "outlined"
                            }
                            onClick={() => handleAddonClick(addOn)}
                          >
                            {addOn.addOnName} [ ₹ {addOn.price} ]
                          </Button>
                        ))}
                      </Box>

                      {[
                        ...new Map(
                          mappedProducts.map((p) => [p.productId, p])
                        ).values()
                      ].length > 0 && (
                        <>
                          <Divider sx={{ my: 2 }} />
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            gutterBottom
                          >
                            Products from selected service
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                              maxHeight: 200,
                              overflowY: "auto"
                            }}
                          >
                            {[
                              ...new Map(
                                mappedProducts.map((p) => [p.productId, p])
                              ).values()
                            ].map((product) => {
                              const quantity =
                                productQuantities[product.productId] || 0;

                              return (
                                <Box
                                  key={product.productId}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 1,
                                    p: 1
                                  }}
                                >
                                  <img
                                    src={`${config.imgUrl}/${product.imageUrl}`}
                                    alt={product.productName}
                                    width={40}
                                    height={40}
                                    style={{
                                      objectFit: "cover",
                                      borderRadius: 4
                                    }}
                                  />

                                  <Box flex={1}>
                                    <Typography variant="body2">
                                      {product.productName}
                                    </Typography>
                                    {/* <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      ₹ {product.price}
                                    </Typography> */}
                                  </Box>

                                  {/* Quantity Controls */}
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                  >
                                    <IconButton
                                      onClick={() =>
                                        handleProductQuantityChange(
                                          product.productId,
                                          quantity - 1
                                        )
                                      }
                                    >
                                      <Remove />
                                    </IconButton>
                                    <TextField
                                      type="number"
                                      size="small"
                                      value={quantity}
                                      onChange={(e) =>
                                        handleProductQuantityChange(
                                          product.productId,
                                          +e.target.value
                                        )
                                      }
                                      inputProps={{
                                        min: 1,
                                        style: { textAlign: "center" }
                                      }}
                                      sx={{ minWidth: 60, width: "auto" }}
                                    />

                                    <IconButton
                                      onClick={() =>
                                        handleProductQuantityChange(
                                          product.productId,
                                          quantity + 1
                                        )
                                      }
                                    >
                                      <Add />
                                    </IconButton>
                                  </Box>
                                </Box>
                              );
                            })}
                          </Box>
                        </>
                      )}

                      {/* Quantity or Weight Selector */}
                      {selectedServices.length > 0 &&
                        (selectedServices.some((s) => s.isWeightBased) ? (
                          // If any selected service is weight-based
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            my={2}
                            gap={1}
                          >
                            <Typography variant="body2" fontWeight="bold">
                              Enter Total Weight (KG):
                            </Typography>
                            <TextField
                              type="number"
                              value={weight}
                              onChange={(e) =>
                                handleWeightChange(Number(e.target.value))
                              }
                              sx={{ width: 80 }}
                              inputProps={{ min: 1 }}
                            />
                          </Box>
                        ) : (
                          // Otherwise, show quantity
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            my={2}
                          >
                            <IconButton
                              onClick={() =>
                                handleQuantityChange(Math.max(1, quantity - 1))
                              }
                            >
                              <Remove />
                            </IconButton>
                            <Typography variant="body2" fontWeight="bold">
                              Enter Total Quantity:
                            </Typography>
                            <TextField
                              type="number"
                              value={quantity}
                              onChange={(e) =>
                                handleQuantityChange(Number(e.target.value))
                              }
                              sx={{ width: 60, mx: 1, textAlign: "center" }}
                              inputProps={{ min: 1 }}
                            />
                            <IconButton
                              onClick={() => handleQuantityChange(quantity + 1)}
                            >
                              <Add />
                            </IconButton>
                          </Box>
                        ))}

                      {/* Save Button */}
                      <WSButton
                        id="saveBtn"
                        label="Save Product"
                        variant="contained"
                        size="medium"
                        sx={{ mt: 2, width: "100%" }} // Make it full width
                        onClick={handleSaveProduct}
                      />
                    </Box>
                  </Drawer>

                  <ConfirmDialog
                    title="Confirm Print"
                    question="Do you want to print the tags?"
                    open={openPrintModal}
                    onClose={() => {
                      setOpenPrintModal(false);
                      navigate("/home");
                    }}
                    onConfirm={handlePrint}
                    actionText1="No, Later"
                    actionText2="Yes"
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
};
